import _ from "lodash";
import MultiDateSelector from "../input-date/MultiDateSelector";
import InputSearchList from "../input-search/InputSearchList";
import InputSearchTag from "../input-search/InputSearchTag";
import { VAR_TYPES } from "constants/constants";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

const EditableCell = ({
  value: initialValue,
  variable,
  updateData,
  id,
  formValues,
  search,
  onRemove,
  minDate,
  getYear,
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);

  const onChange = (e) => {
    const handlers = {
      [VAR_TYPES.DROPDOWN]: () => updateData(variable, e.target.value),
      [VAR_TYPES.TAGS]: () => updateData(variable, e),
      [VAR_TYPES.SEARCH]: () => updateData(variable, e),
      [VAR_TYPES.FILE]: () => updateData(variable, e),
      [VAR_TYPES.MULTI_DATES]: () => updateData(variable, e),
      default: () => setValue(e.target.value),
    };

    (handlers[variable.type] || handlers.default)();
  };

  // We'll only update the external data when the input is blurred
  const onBlur = (e) => {
    updateData(variable, e.target.value);
  };

  useEffect(() => {
    if (variable?.type === VAR_TYPES.DROPDOWN) {
      setValue((variable?.choices && variable.choices[0]) || "");
    } else {
      setValue(initialValue);
    }
  }, [initialValue]);

  if (variable.type && variable.type === VAR_TYPES.DROPDOWN) {
    return (
      <select
        value={formValues[variable.col] || value}
        onChange={(e) => {
          onChange(e);
          getYear && getYear(e.target.value);
        }}
        onBlur={onBlur}
        id={id}
        style={{ borderColor: variable.isMissingValue || null }}
      >
        {variable.choices?.map((e, i) => (
          <option key={`option-${i}`} value={e.value}>
            {e.name}
          </option>
        ))}
      </select>
    );
  } else if (variable.type && variable.type === VAR_TYPES.TAGS) {
    return (
      <InputSearchTag
        isBo
        limitChoice={variable?.limitChoice ?? 10}
        options={variable?.choices || []}
        popup={variable?.popup}
        selectedOptions={formValues[variable.col]}
        minLength={2}
        getOptions={(val) => (variable?.search ? search(val) : null)}
        setValue={onChange}
        onDelete={(val) => {
          onRemove(variable?.col, val);
        }}
        id={formValues[variable.col] || ""}
        errors={{ isMissingValue: variable?.isMissingValue }}
      />
    );
  } else if (variable.type && variable.type === VAR_TYPES.SEARCH) {
    return (
      <InputSearchList
        isBo
        limitChoice={1}
        options={variable?.choices || []}
        popup={variable?.popup}
        selectedOptions={formValues[variable.col]}
        minLength={2}
        getOptions={(val) => (variable.search ? search(val) : null)}
        setValue={onChange}
        errors={{ isMissingValue: variable?.isMissingValue }}
      />
    );
  } else if (variable.type && variable.type === VAR_TYPES.FILE) {
    return (
      <>
        <input
          type="file"
          className="input-hidden"
          accept={variable?.fileType ? variable.fileType : "image/*"}
          id={id}
          onChange={onChange}
        />
        <br />
        <label>{typeof value === "string" ? value : ""}</label>
        {variable?.label && <label>{variable.label}</label>}
      </>
    );
  } else if (variable.type && variable.type === VAR_TYPES.MULTI_DATES) {
    return (
      <MultiDateSelector
        min={minDate}
        onChange={onChange}
        value={value}
        error={variable.isMissingValue}
        defaultValue={
          _.map(initialValue, (elm) => (elm?.date ? elm?.date : elm)) || []
        }
      />
    );
  } else {
    return (
      <input
        style={{ borderColor: variable.isMissingValue || null }}
        value={variable?.defaultValue || value}
        id={id}
        onChange={onChange}
        onBlur={onBlur}
        type={variable.type || VAR_TYPES.TEXT}
        step={variable.step ?? ""}
        required={variable.mandatory}
        disabled={variable?.disabled}
      />
    );
  }
};

EditableCell.propTypes = {
  value: PropTypes.any,
  variable: PropTypes.object,
  updateData: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formValues: PropTypes.object,
  search: PropTypes.func,
  onRemove: PropTypes.func,
  minDate: PropTypes.object,
  getYear: PropTypes.func,
};

export default EditableCell;
